export default __webpack_public_path__ + "static/media/AT.a7262b53.svg";